import type { Activity, HeightBand } from '@/types/quiz'

export interface HeightOption {
  id: HeightBand
  label: string
  /** Shown beneath the main band label (cm equivalent). */
  subLabel: string
}

/**
 * Height bands shown on Screen 4. The cutoff between short and regular
 * shifts by activity: snowboarders run regular from 5'2" up, skiers and
 * snow-play customers from 5'3" up - boots and break-over-cuff differ
 * enough that the same body height calls for a different inseam.
 *
 * No length-tag chip on the card any more - we don't want to pre-tell the
 * customer what we'd recommend before they answer; let them pick on height
 * alone and surface the inseam in the final result.
 */
export const HEIGHT_OPTIONS_BY_ACTIVITY: Record<Activity, readonly HeightOption[]> = {
  snowboard: [
    { id: 'short',   label: "Under 5'2\"",     subLabel: '156cm and under'  },
    { id: 'regular', label: "5'2\" to 5'8\"",  subLabel: '157cm to 174cm'   },
    { id: 'tall',    label: "5'9\" or taller", subLabel: '175cm and above'  },
  ],
  ski: [
    { id: 'short',   label: "5'2\" or under",  subLabel: '158cm and under'  },
    { id: 'regular', label: "5'3\" to 5'8\"",  subLabel: '160cm to 174cm'   },
    { id: 'tall',    label: "5'9\" or taller", subLabel: '175cm and above'  },
  ],
  snowplay: [
    { id: 'short',   label: "5'2\" or under",  subLabel: '158cm and under'  },
    { id: 'regular', label: "5'3\" to 5'8\"",  subLabel: '160cm to 174cm'   },
    { id: 'tall',    label: "5'9\" or taller", subLabel: '175cm and above'  },
  ],
}

/** Convenience accessor used by the Height screen. */
export function heightOptionsFor(activity: Activity): readonly HeightOption[] {
  return HEIGHT_OPTIONS_BY_ACTIVITY[activity]
}
